import React from "react";

function NoData() {

    return(
         <div className="nodata-container" style={{height: '673.133px'}}>
        <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon"><use xlinkHref="#nodata_f4c19c2d" /></svg>
        <p className>No data</p>
    </div>
    );

}
export default NoData;